import index from './index/index.vue'
import renew from './renew/index.vue'
import financial from './financial/index.vue'

export default {
  index,
  renew,
  financial
}
